"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTS = void 0;
exports.EVENTS = {
    onClick: 'click',
    onMousedown: 'mousedown',
    onMouseup: 'mouseup',
    onDblclick: 'dblclick',
    onMouseout: 'mouseout',
    onMouseover: 'mouseover',
    onMousemove: 'mousemove',
    onMouseleave: 'mouseleave',
    onMouseenter: 'mouseenter',
    onTouchstart: 'touchstart',
    onTouchmove: 'touchmove',
    onTouchend: 'touchend',
    onDragenter: 'dragenter',
    onDragover: 'dragover',
    onDragleave: 'dragleave',
    onDrop: 'drop',
    onContextmenu: 'contextmenu',
};
//# sourceMappingURL=events.js.map